// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-761c9a50]{font-size:18px;font-weight:700}hr[data-v-761c9a50]{margin:0}.number[data-v-761c9a50]{padding-left:10px;border-bottom-right-radius:0;border-top-right-radius:0;font-size:18px}.gblock[data-v-761c9a50]{background:#deeaff;color:#485291;padding:12px;border-radius:8px;text-align:center;font-size:12px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
